import { createRouter, createWebHistory } from 'vue-router'

// 移动端页面组件
import MobileApp from '../MobileApp.vue'
import HomePage from '../views/Home/HomePage.vue'
import PurchasePage from '../views/Purchase/PurchasePage.vue'
import SalesPage from '../views/Sales/SalesPage.vue'
import InventoryPage from '../views/Inventory/InventoryPage.vue'
import FinancePage from '../views/Finance/FinancePage.vue'

const routes = [
  {
    path: '/mobile',
    component: MobileApp,
    children: [
      {
        path: '',
        redirect: '/mobile/home'
      },
      {
        path: 'home',
        name: 'MobileHome',
        component: HomePage,
        meta: {
          title: '首页',
          showTabBar: true,
          showBackButton: false
        }
      },
      {
        path: 'purchase',
        name: 'MobilePurchase',
        component: PurchasePage,
        meta: {
          title: '进货管理',
          showTabBar: true,
          showBackButton: false
        }
      },
      {
        path: 'sales',
        name: 'MobileSales',
        component: SalesPage,
        meta: {
          title: '销售管理',
          showTabBar: true,
          showBackButton: false
        }
      },
      {
        path: 'inventory',
        name: 'MobileInventory',
        component: InventoryPage,
        meta: {
          title: '库存管理',
          showTabBar: true,
          showBackButton: false
        }
      },
      {
        path: 'finance',
        name: 'MobileFinance',
        component: FinancePage,
        meta: {
          title: '财务管理',
          showTabBar: true,
          showBackButton: false
        }
      },
      // 进货模块子页面
      {
        path: 'purchase/return',
        name: 'PurchaseReturnList',
        component: () => import('../views/Purchase/PurchaseReturnList.vue'),
        meta: {
          title: '进货退货',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'purchase/add',
        name: 'PurchaseAdd',
        component: () => import('../views/Purchase/PurchaseAdd.vue'),
        meta: {
          title: '新增进货',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'purchase/return-add',
        name: 'PurchaseReturnAdd',
        component: () => import('../views/Purchase/PurchaseReturnAdd.vue'),
        meta: {
          title: '新增进货退货',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'purchase/return-list',
        name: 'PurchaseReturnList',
        component: () => import('../views/Purchase/PurchaseReturnList.vue'),
        meta: {
          title: '进货退货列表',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'purchase/return/detail/:id',
        name: 'PurchaseReturnDetail',
        component: () => import('../views/Purchase/PurchaseReturnDetail.vue'),
        meta: {
          title: '进货退货详情',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'purchase/return/detail/:id',
        name: 'PurchaseReturnDetail',
        component: () => import('../views/Purchase/PurchaseReturnDetail.vue'),
        meta: {
          title: '进货退货详情',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'purchase/detail/:id',
        name: 'PurchaseDetail',
        component: () => import('../views/Purchase/PurchaseDetail.vue'),
        meta: {
          title: '进货详情',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'purchase/print/:id',
        name: 'PurchasePrint',
        component: () => import('../views/Purchase/PurchasePrint.vue'),
        meta: {
          title: '打印预览',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'purchase/suppliers',
        name: 'SupplierManagement',
        component: () => import('../views/Purchase/SupplierManagement.vue'),
        meta: {
          title: '供应商管理',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'purchase/supplier/:id',
        name: 'SupplierDetail',
        component: () => import('../views/Purchase/SupplierDetail.vue'),
        meta: {
          title: '供应商详情',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'purchase/supplier-category',
        name: 'SupplierCategoryManage',
        component: () => import('../views/Purchase/SupplierCategoryManage.vue'),
        meta: {
          title: '供应商分类管理',
          showTabBar: false,
          showBackButton: true
        }
      },
      
      // 销售模块子页面
      {
        path: 'sales/return',
        name: 'SalesReturnList',
        component: () => import('../views/Sales/SalesReturnList.vue'),
        meta: {
          title: '销售退货',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'sales/add',
        name: 'SalesAdd',
        component: () => import('../views/Sales/SalesAdd.vue'),
        meta: {
          title: '新增销售',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'sales/return-add',
        name: 'SalesReturnAdd',
        component: () => import('../views/Sales/SalesReturnAdd.vue'),
        meta: {
          title: '新增销售退货',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'sales/return-list',
        name: 'SalesReturnList',
        component: () => import('../views/Sales/SalesReturnList.vue'),
        meta: {
          title: '销售退货列表',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'sales/return/detail/:id',
        name: 'SalesReturnDetail',
        component: () => import('../views/Sales/SalesReturnDetail.vue'),
        meta: {
          title: '销售退货详情',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'sales/return/detail/:id',
        name: 'SalesReturnDetail',
        component: () => import('../views/Sales/SalesReturnDetail.vue'),
        meta: {
          title: '销售退货详情',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'home/sales-report',
        name: 'SalesReport',
        component: () => import('../views/Home/SalesReport.vue'),
        meta: {
          title: '销售报表',
          showTabBar: true,
          showBackButton: false
        }
      },
      {
        path: 'sales/detail/:id',
        name: 'SalesDetail',
        component: () => import('../views/Sales/SalesDetail.vue'),
        meta: {
          title: '销售详情',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'sales/customers',
        name: 'CustomerManagement',
        component: () => import('../views/Sales/CustomerManagement.vue'),
        meta: {
          title: '客户管理',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'sales/customer/:id',
        name: 'CustomerDetail',
        component: () => import('../views/Sales/CustomerDetail.vue'),
        meta: {
          title: '客户详情',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'sales/customer-category',
        name: 'CustomerCategoryManage',
        component: () => import('../views/Sales/CustomerCategoryManage.vue'),
        meta: {
          title: '客户分类管理',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'sales/print/:id',
        name: 'SalesPrint',
        component: () => import('../views/Sales/SalesPrint.vue'),
        meta: {
          title: '打印预览',
          showTabBar: false,
          showBackButton: true
        }
      },
      
      // 库存模块子页面
      {
        path: 'inventory/detail/:id',
        name: 'InventoryDetail',
        component: () => import('../views/Inventory/InventoryDetail.vue'),
        meta: {
          title: '库存详情',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'inventory/adjust/:id',
        name: 'InventoryAdjust',
        component: () => import('../views/Inventory/InventoryAdjust.vue'),
        meta: {
          title: '库存调整',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'inventory/check',
        name: 'InventoryCheck',
        component: () => import('../views/Inventory/InventoryCheck.vue'),
        meta: {
          title: '库存盘点',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'inventory/transfer',
        name: 'InventoryTransfer',
        component: () => import('../views/Inventory/InventoryTransfer.vue'),
        meta: {
          title: '库存调拨',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'inventory/history/:id',
        name: 'InventoryHistory',
        component: () => import('../views/Inventory/InventoryHistory.vue'),
        meta: {
          title: '库存历史',
          showTabBar: false,
          showBackButton: true
        }
      },
      
      // 财务模块子页面
      {
        path: 'finance/invoice/add',
        name: 'MobileInvoiceAdd',
        component: () => import('../views/Finance/InvoiceAdd.vue'),
        meta: {
          title: '新建发票',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'finance/report',
        name: 'FinanceReport',
        component: () => import('../views/Finance/FinanceReport.vue'),
        meta: {
          title: '财务报表',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'finance/cashflow',
        name: 'CashFlow',
        component: () => import('../views/Finance/CashFlow.vue'),
        meta: {
          title: '资金流水',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'finance/receivable',
        name: 'Receivable',
        component: () => import('../views/Finance/Receivable.vue'),
        meta: {
          title: '应收账款',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'finance/payable',
        name: 'Payable',
        component: () => import('../views/Finance/Payable.vue'),
        meta: {
          title: '应付账款',
          showTabBar: false,
          showBackButton: true
        }
      },
      
      // 收款单相关路由
      {
        path: 'finance/receipt/list',
        name: 'MobileReceiptList',
        component: () => import('../views/Finance/ReceiptList.vue'),
        meta: {
          title: '收款单列表',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'finance/receipt/add',
        name: 'MobileReceiptAdd',
        component: () => import('../views/Finance/ReceiptAdd.vue'),
        meta: {
          title: '新建收款单',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'finance/receipt/edit/:id',
        name: 'MobileReceiptEdit',
        component: () => import('../views/Finance/ReceiptAdd.vue'),
        meta: {
          title: '编辑收款单',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'finance/receipt/detail/:id',
        name: 'MobileReceiptDetail',
        component: () => import('../views/Finance/ReceiptAdd.vue'),
        meta: {
          title: '收款单详情',
          showTabBar: false,
          showBackButton: true
        }
      },
      // 付款单相关路由
      {
        path: 'finance/payment/list',
        name: 'MobilePaymentList',
        component: () => import('../views/Finance/PaymentList.vue'),
        meta: {
          title: '付款单列表',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'finance/payment/add',
        name: 'MobilePaymentAdd',
        component: () => import('../views/Finance/PaymentAdd.vue'),
        meta: {
          title: '新建付款单',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'finance/payment/edit/:id',
        name: 'MobilePaymentEdit',
        component: () => import('../views/Finance/PaymentAdd.vue'),
        meta: {
          title: '编辑付款单',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'finance/payment/detail/:id',
        name: 'MobilePaymentDetail',
        component: () => import('../views/Finance/PaymentAdd.vue'),
        meta: {
          title: '付款单详情',
          showTabBar: false,
          showBackButton: true
        }
      },
      
      // 系统页面
      {
        path: 'finance/writeoff/list',
        name: 'MobileWriteOffList',
        component: () => import('../views/Finance/WriteOffVoucherList.vue'),
        meta: {
          title: '核销单列表',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'finance/writeoff/add',
        name: 'MobileWriteOffAdd',
        component: () => import('../views/Finance/WriteOffVoucherForm.vue'),
        meta: {
          title: '新建核销单',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'finance/writeoff/edit/:id',
        name: 'MobileWriteOffEdit',
        component: () => import('../views/Finance/WriteOffVoucherForm.vue'),
        meta: {
          title: '编辑核销单',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'finance/writeoff/detail/:id',
        name: 'MobileWriteOffDetail',
        component: () => import('../views/Finance/WriteOffVoucherForm.vue'),
        meta: {
          title: '核销单详情',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'settings',
        name: 'MobileSettings',
        component: () => import('../views/System/Settings.vue'),
        meta: {
          title: '系统设置',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'profile',
        name: 'MobileProfile',
        component: () => import('../views/System/Profile.vue'),
        meta: {
          title: '个人中心',
          showTabBar: false,
          showBackButton: true
        }
      },
      // 审批申请新增页面（复用网页端审批管理的申请表单）
      {
        path: 'approval/payment/add',
        name: 'MobileApprovalPaymentAdd',
        component: () => import('../../views/ApprovalV2/PaymentAdd.vue'),
        meta: {
          title: '新建付款申请',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'approval/invoice/add',
        name: 'MobileApprovalInvoiceAdd',
        component: () => import('../../views/ApprovalV2/InvoiceAdd.vue'),
        meta: {
          title: '新建发票申请',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'approval/seal/add',
        name: 'MobileApprovalSealAdd',
        component: () => import('../../views/ApprovalV2/SealAdd.vue'),
        meta: {
          title: '新建印章申请',
          showTabBar: false,
          showBackButton: true
        }
      },

      // 审批中心
      {
        path: 'approval',
        name: 'MobileApprovalList',
        component: () => import('../views/Approval/ApprovalList.vue'),
        meta: {
          title: '审批中心',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'approval/invoice/:id',
        name: 'MobileInvoiceDetail',
        component: () => import('../views/Approval/InvoiceDetail.vue'),
        meta: {
          title: '开票审批详情',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'approval/seal/:id',
        name: 'MobileSealDetail',
        component: () => import('../views/Approval/SealDetail.vue'),
        meta: {
          title: '用章审批详情',
          showTabBar: false,
          showBackButton: true
        }
      },
      {
        path: 'approval/payment/:id',
        name: 'MobilePaymentApprovalDetail',
        component: () => import('../views/Approval/PaymentDetail.vue'),
        meta: {
          title: '付款审批详情',
          showTabBar: false,
          showBackButton: true
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 检查登录状态
  const token = localStorage.getItem('token')
  
  if (to.path.startsWith('/mobile') && !token) {
    // 如果访问移动端页面但未登录，跳转到登录页
    next('/login')
    return
  }
  
  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - ERP移动端`
  }
  
  next()
})

export default router
